// extracted by mini-css-extract-plugin
export default {"line":"NeareatServiceCenter_line__4qF+v","title":"NeareatServiceCenter_title__IP6ji","informationBlock":"NeareatServiceCenter_informationBlock__Mrrue"};